module.exports = __webpack_public_path__ + "d61e1005471b5696e743aedc791c5933.svg";